import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import type { AppDispatch } from '@/app/store';
import { selectThemeMode, toggleTheme, setTheme } from './themeSlice';
import type { Theme } from './themeSlice';

export function useTheme() {
  const dispatch = useDispatch<AppDispatch>();
  const mode = useSelector(selectThemeMode);

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', mode);
  }, [mode]);

  return {
    mode,
    toggle: () => dispatch(toggleTheme()),
    setMode: (m: Theme) => dispatch(setTheme(m))
  };
}
